// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__-SMUh","actionButton":"sidebar_actionButton__kS4y7"};